import { FormControl, MenuItem, Select } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { getPlansComparative } from "../../actions/plans";
import styles from "./styles";
import { showSuccessSnackbar } from "../../actions/snackBar";
export const SelectItem = ({
  id,
  listPlans,
  handleSelectedPlan,
  action,
  auxSelectedItem
}) => {
  const dispatch = useDispatch();
  const classes = styles();
  const [selectedItem, setSelectedItem] = React.useState(``);

  const handleChangeItem = event => {
    const item = event.target.value;
    setSelectedItem(`${item}`);
    handleSelectedPlan(action, item);
  };
  useEffect(() => {
    const defaultPlans = listPlans.filter(plan => plan.default === true);
    switch (action) {
      case "selectOne":
        setSelectedItem(defaultPlans[0]?.id ? defaultPlans[0]?.id : "");
        return;
      case "selectSecond":
        setSelectedItem(defaultPlans[1]?.id ? defaultPlans[1]?.id : "");
        return;
      case "selectThree":
        setSelectedItem(defaultPlans[2]?.id ? defaultPlans[2]?.id : "");
        return;
    }
  }, []);

  useEffect(() => {
    if (auxSelectedItem) {
      if (auxSelectedItem.error) {
        // dispatch(showSuccessSnackbar(auxSelectedItem.error, "Error"));
        // console.log(
        //   "🚀 useEffect ~ auxSelectedItem.error",
        //   auxSelectedItem.error
        // );
      }
      setSelectedItem(auxSelectedItem.id);
    }
  }, [auxSelectedItem]);

  return (
    <FormControl variant="outlined" className={classes.root}>
      <Select
        native
        id={`select-item-${id}`}
        value={selectedItem}
        onChange={handleChangeItem}
        className={classes.selectStyles}
        IconComponent={ExpandMoreIcon}
      >
        {listPlans.map(plan => {
          return (
            <option
              className={classes.menuItemStyle}
              key={plan.id}
              value={`${plan.id}`}
            >
              {plan.name}
            </option>
          );
        })}
      </Select>
    </FormControl>
  );
};
SelectItem.propTypes = {
  id: PropTypes.number,
  listPlans: PropTypes.array,
  handleSelectedPlan: PropTypes.any,
  action: PropTypes.string,
  auxSelectedItem: PropTypes.any
};
